import React, { Component } from "react";
import ScrollToTop from "../skins/cbSkin/components/ScrollToTop";
import Components from '../ComponentIndex';
import { BrowserRouter, Route, Switch } from "react-router-dom";
class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const date = new Date();
    const nanoSec = date.getMilliseconds();
    return (
      <BrowserRouter>
        {/* <ScrollToTop> */}
          <section className="full-width-cont">
            <Switch>
              {<Route exact key={nanoSec} path="**" component={Components[this.props.skin+"_MainLayout"]} />}
            </Switch>
          </section>
        {/* </ScrollToTop> */}
      </BrowserRouter>
    );
  }
}

export default Routes;
